import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import {movies} from './movies.js';
import MoviePreviewTwo from './moviepreview';
import MovieInformation from'./movieInformation';

class App extends Component {

  _setCurrentMovie = (movie) => {
    console.log('movie',movie);
    this.setState({
      currentMovie: movie
      
    });
  };

  constructor(props) {
    super(props);
    this.setCurrentMovie = this._setCurrentMovie.bind(this);
    this.state = {
        currentMovie: null
    };
  }



  render() {
    return (
     <div className="App">
       {
         movies.map((movie) => {
            return (
             <MoviePreviewTwo
             movie= {movie} 
             setCurrentMovieFunction= {this.setCurrentMovie}
            / >
                     
              ); 
            })

          }
        
         <div>
           {
             this.state.currentMovie != null
             ?
             <MovieInformation
             currentMovie={this.state.currentMovie}
             />
             :
             <p>{'Please select a movie.'}</p>
           }
         </div>
        <div className="bottom">
        </div>

      </div> 
    );
  } 
} 

export default App;
